function getCountdownColour(jobTask)
{
    let d = new Date()
    let messageDate = new Date(jobTask.dueDate)
    let dayDiff = Math.ceil((messageDate - d) / (1000 * 60 * 60 * 24))
    if (dayDiff > 7) {
        return "#006400"
    }
    switch (dayDiff) {
        case 7:
        case 6:
            return "#9acd32"
        case 5:
        case 4:
            return "#f0e68c"
        case 3:
            return "#ff8c00"
        case 2:
        case 1:
            return "#ef1111"
        default:
            return "#a9a9a9"

    }
}

export const MARKERTYPE_UNKNOWN = 0
export const MARKERTYPE_TWOTRIP_UNKNOWN = 1
export const MARKERTYPE_OVERHEAD = 2
export const MARKERTYPE_UNDERGROUND = 3
export const MARKERTYPE_DEMO = 4
export const MARKERTYPE_MEET = 5
export const MARKERTYPE_ONAFTER = 6
export const MARKERTYPE_CONFINED = 7
export const MARKERTYPE_RUSH = 8
export const MARKERTYPE_TWOTRIP_OH = 9
export const MARKERTPYE_TWOTRIP_UG = 10
//export const MARKERTYPE_SHOP = 11

function parseType(task){
    let date = new Date()
    let taskDate = new Date(task.dueDate)

    if(!(task.notes) || !(task.taskType)){
        return task.twoTrip ?  MARKERTYPE_TWOTRIP_UNKNOWN : MARKERTYPE_UNKNOWN
    }
    if(task.priority === "OnOrAfter") {
        if (date < taskDate) {
            return MARKERTYPE_ONAFTER
        }
    } else {
            const notes = task.notes.toLowerCase()
            const type = task.taskType.toLowerCase()
            if (notes.includes("confined") || type.includes("confined")) {
                return MARKERTYPE_CONFINED
            }
            if (type.includes("demo") || notes.includes("demo")) {
                return MARKERTYPE_DEMO
            }
            if (type.includes("rush") || notes.includes("rush")) {
                return MARKERTYPE_RUSH
            }
            if (notes.includes("ww") || notes.includes("w/w") || (notes.includes('work') && (notes.includes('with')))) {
                return MARKERTYPE_MEET
            }
            if (notes.includes(" ug ") || notes.includes("u/g") || (notes.includes('underground')) || type.includes('underground')) {
                return task.twoTrip ? MARKERTPYE_TWOTRIP_UG : MARKERTYPE_UNDERGROUND
            }
            if (notes.includes(" oh ") || notes.includes("o/h") || (notes.includes('overhead')) || type.includes('overhead')) {
                return task.twoTrip ? MARKERTYPE_TWOTRIP_OH : MARKERTYPE_OVERHEAD

            }
            return task.twoTrip ? MARKERTYPE_TWOTRIP_UNKNOWN : MARKERTYPE_UNKNOWN
        }
}

function getStyle(el, markerType){
    switch(markerType){
        case MARKERTYPE_OVERHEAD:
            el.className += ' marker-pin-overhead'
            return el
        case MARKERTYPE_UNDERGROUND:
            el.className += ' marker-pin-underground'
            return el
        case MARKERTYPE_UNKNOWN: {
            el.className += ' marker-pin-unknown'
            return el
        }
        case MARKERTPYE_TWOTRIP_UG: {
            el.className += ' marker-two-trip-underground'
            return el
        }
        case MARKERTYPE_TWOTRIP_OH: {
            el.className += ' marker-two-trip-overhead'
            return el
        }
        case MARKERTYPE_TWOTRIP_UNKNOWN : {
            el.className += ' marker-two-trip-unknown'
            return el
        }
        case MARKERTYPE_MEET: {
            el.className += ' marker-meet'
            return el
        }
        case MARKERTYPE_DEMO: {
            el.className += ' marker-demo'
            return el
        }
        case MARKERTYPE_ONAFTER: {
            el.className += ' marker-on-after'
            return el
        }
        case MARKERTYPE_RUSH: {
            el.className += 'marker-rush'
            return el
        }
        case MARKERTYPE_CONFINED: {
            el.className += ' marker-confined'
            return el
        }
        default: {
            el.className += ' marker-pin-unknown'
            return el
        }
    }
}
function getElement(markerType){
    let el = document.createElement('div')
    el.className = 'marker-general'
    return (getStyle(el, markerType))
}

function getHighlightElement(markerType) {
    let el = document.createElement('div')
    el.className = 'marker-bigger'
    return(getStyle(el, markerType))
}

function getNumberIconElementForIconId(id, useSelectedIcon){
    let el = document.createElement('div')
    if(useSelectedIcon){
        el.className = 'select-'
    }
    if(id == null || id === 0){
        el.className += 'marker-order marker-pin-unknown'
        return el
    }
    el.className += 'marker-order order-icon-' + id.toString()
    return el
}

function getSelectedElement(){
    let el = document.createElement('div')
    el.className = 'marker-selected'
    return el
}
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


export default {
    getCountdownColour,
    getNumberIconElementForIconId,
    parseType,
    sleep,
    getElement,
    getSelectedElement,
    getHighlightElement,
}

